import {map} from 'rxjs/operators';
import type {AutocompleteSearchFunction} from '../components/kp-search-input/search-input.provider';
import type SearchInputServiceProvider from '../components/kp-search-input/search-input.provider';
import type AutocompleteSearchDataService from '../data-services/autocomplete-search.data-service';

/*@ngInject*/
export default function mainMenuConfig(searchInputServiceProvider: SearchInputServiceProvider) {

    /*@ngInject*/
    const searchFunction = (searchPhrase: string, globalSearchService) => {
        globalSearchService.search(searchPhrase);
    };

    /*@ngInject*/
    const autocompleteSearchFunction: AutocompleteSearchFunction = (searchPhrase: string, CONTEXT_PATH: string, autocompleteSearchDataService: AutocompleteSearchDataService) => {
        return autocompleteSearchDataService.getSearchedTerms(searchPhrase).pipe(
            map((response) => response.content.map((item) => item.value))
        );
    };

    searchInputServiceProvider.setAutocompleteSearchFunction(autocompleteSearchFunction);

    searchInputServiceProvider.setSearchFunction(searchFunction);
}
